<template>
  <div>
    <!--回退收费名义设置  -->
    <el-dialog :title="$t('message.backoffChargeNominalSetting')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <!-- 新增类别 -->
        <div class="row">
          <el-button type="success" size="small" @click="add">{{
            $t("message.newCategoriesAdded")
          }}</el-button>
        </div>

        <div class="table">
          <ol>

            <!-- 回退追加收费名义 -->
            <li class="flex2">
              {{ $t("message.returnTheAdditionalCharge") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">

            <!-- 回退追加收费名义 -->
            <li class="flex2">
              <el-input v-model="item.name"></el-input>
            </li>
            <!-- 操作 -->
            <li>
              <el-button type="success" size="small" class="dark" @click="configReasonDelete(item.id, index)">{{
                $t("message.delete") }}</el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="backChargeSet">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    //列表
    backChargeList() {
      this.$api.porderApi.backChargeList().then((res) => {
        this.tableData = res.data;
      });
    },
    //售后-调整原因-设置
    backChargeSet() {
      let datas = {
        list: [],
      }
      this.tableData.forEach(item => {
        datas.list.push(item.name)
      })
      this.$api.porderApi.backChargeSet(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false

      });
    },
    //新增
    add() {
      this.tableData.push({
        id: 0,
        name: "",
      });
    },
    //删除
    configReasonDelete(id, i) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.tableData.splice(i, 1);

        })
        .catch(() => { });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.backChargeList();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px 30px;

  .row {
    text-align: right;
    margin-bottom: 20px;
  }

  .table {
    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    .flex2 {
      flex: 4;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>